__webpack_require__.p = "/wp-content/plugins/klangio_ai2notes_widgets/assets/";